module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conversions-container",
    style: (("border-bottom: 0.1rem solid " + (_vm.globalColors.border) + ";border-top: 0.1rem solid " + (_vm.globalColors.border) + ";"))
  }, [_c('h3', {
    class: ['conversions-title'],
    style: (("color:" + (_vm.globalColors.titulo)))
  }, [_vm._v("Presentaciones:")]), _vm._v(" "), _c('div', {
    staticClass: "conversion-button-container"
  }, _vm._l((_vm.conversionsComputed), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "btn-conversions",
      style: (("border:1px solid " + (_vm.globalColors.primary) + ";color: " + (item.isSelected ? 'white' : _vm.globalColors.primary) + ";background-color: " + (item.isSelected ? _vm.globalColors.primary : 'white'))),
      attrs: {
        "type": "button",
        "value": _vm.defaultUnit
      },
      on: {
        "click": function($event) {
          _vm.selectedConversion(item)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(item.name) + "\n\t\t")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a053f36","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/productConversion.vue
// module id = 1097
// module chunks = 1